/**
 * VEGEGROW - メインJavaScriptファイル
 * 
 * @package VEGEGROW
 * @version 1.0.0
 */

(function() {
    
    // DOM読み込み完了後の処理
    document.addEventListener('DOMContentLoaded', function() {
        initLoadingScreen();
        initProductsAnimation();
        initNewsAnimation();
        initInstagramFeed();
        initAboutAnimation();
        initContactAnimation();
        initHamburgerMenu();
        initSmoothScroll();
        initNavigationActiveState();
    });
    
    // 全リソース読み込み完了後の処理（Swiper用）
    window.addEventListener('load', function() {
        initHeroSwiper();
        // ローディング完了処理
        completeLoading();
    });
    
    /**
     * ローディング画面の初期化
     */
    function initLoadingScreen() {
        const loadingScreen = document.getElementById('loading-screen');
        const mainContent = document.getElementById('main-content');
        
        if (!loadingScreen || !mainContent) {
            console.warn('Loading screen elements not found');
            return;
        }
        
        // 初期状態：ローディング画面を表示、メインコンテンツを非表示
        loadingScreen.classList.remove('is-hidden');
        mainContent.classList.remove('is-visible');
        
        console.log('Loading screen initialized');
    }
    
    /**
     * ローディング完了処理
     */
    function completeLoading() {
        const loadingScreen = document.getElementById('loading-screen');
        const mainContent = document.getElementById('main-content');
        
        if (!loadingScreen || !mainContent) {
            console.warn('Loading screen elements not found for completion');
            return;
        }
        
        // 最小ローディング時間を確保（2秒）
        const minLoadingTime = 2000;
        const startTime = performance.now();
        
        function finishLoading() {
            const elapsedTime = performance.now() - startTime;
            const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
            
            setTimeout(() => {
                // メインコンテンツを表示
                mainContent.classList.add('is-visible');
                
                // ローディング画面を非表示（少し遅延）
                setTimeout(() => {
                    loadingScreen.classList.add('is-hidden');
                    
                    // ローディング画面をDOMから削除（メモリ節約）
                    setTimeout(() => {
                        if (loadingScreen.parentNode) {
                            loadingScreen.parentNode.removeChild(loadingScreen);
                        }
                    }, 800); // CSS transition時間と合わせる
                    
                }, 200);
                
                console.log('Loading completed');
            }, remainingTime);
        }
        
        // すべてのリソースが読み込まれたら完了処理を実行
        finishLoading();
    }
    
    /**
     * Our Productsセクションのアニメーション初期化
     */
    function initProductsAnimation() {
        const productsSection = document.querySelector('.products-section');
        
        if (!productsSection) return;
        
        // Intersection Observerでスクロールアニメーション
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '0px 0px -100px 0px'
        });
        
        observer.observe(productsSection);
    }
    
    /**
     * Newsセクションのアニメーション初期化
     */
    function initNewsAnimation() {
        const newsSection = document.querySelector('.news-section');
        
        if (!newsSection) return;
        
        // Intersection Observerでスクロールアニメーション
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '0px 0px -100px 0px'
        });
        
        observer.observe(newsSection);
    }
    
    /**
     * Instagramフィードの初期化
     */
    function initInstagramFeed() {
        const instagramGrid = document.getElementById('instagram-feed');
        
        if (!instagramGrid) {
            console.error('Instagram feed container not found');
            return;
        }
        
        console.log('Instagram feed initialization started');
        
        // Instagram Basic Display APIを使用してフィードを取得
        loadInstagramFeed(instagramGrid);
    }
    
    /**
     * Instagramフィードを読み込む
     * @param {HTMLElement} container - フィードを表示するコンテナ
     */
    function loadInstagramFeed(container) {
        console.log('Loading Instagram feed...');
        
        // ローディング表示
        showLoadingState(container);
        
        // キャッシュからデータを取得
        const cachedData = getCachedInstagramData();
        if (cachedData && !isCacheExpired(cachedData.timestamp)) {
            console.log('Using cached Instagram data');
            displayInstagramPosts(container, cachedData.posts);
            return;
        }
        
        console.log('Fetching fresh Instagram data from API');
        
        // Instagram APIからデータを取得
        fetchInstagramData()
            .then(posts => {
                console.log('Instagram API success:', posts.length, 'posts received');
                // キャッシュに保存
                cacheInstagramData(posts);
                // 表示
                displayInstagramPosts(container, posts);
            })
            .catch(error => {
                console.error('Instagram API Error:', error);
                
                // トークン期限切れの場合は特別なメッセージを表示
                if (error.message && error.message.includes('アクセストークンの有効期限が切れています')) {
                    displayError(container, 'Instagramアクセストークンの有効期限が切れています。新しいトークンを取得して設定してください。');
                    return;
                }
                
                // その他のエラーの場合もエラーメッセージを表示
                if (error.message && error.message.includes('Instagram API error')) {
                    displayError(container, 'Instagramフィードの取得に失敗しました。しばらくしてから再度お試しください。');
                    return;
                }
                
                // フォールバック: サンプルデータを表示
                console.log('Using fallback data');
                displayFallbackData(container);
            });
    }
    
    /**
     * ローディング状態を表示
     * @param {HTMLElement} container - コンテナ要素
     */
    function showLoadingState(container) {
        container.innerHTML = `
            <div class="instagram-loading">
                <div class="instagram-loading__spinner"></div>
                <p class="instagram-loading__text">Instagramフィードを読み込み中...</p>
            </div>
        `;
    }
    
    /**
     * エラーメッセージを表示
     * @param {HTMLElement} container - コンテナ要素
     * @param {string} message - エラーメッセージ
     */
    function displayError(container, message) {
        container.innerHTML = `
            <div class="instagram-error">
                <p class="instagram-error__text">${message}</p>
            </div>
        `;
    }
    
    /**
     * Instagram APIからデータを取得（本番環境用：自前REST APIエンドポイント経由）
     * @returns {Promise<Array>} 投稿データの配列
     */
    async function fetchInstagramData() {
        // 変数を関数スコープで定義（エラーハンドリングで使用するため）
        // WordPressのインストールパスを考慮してベースURLを構築
        const baseUrl = window.location.origin;
        const pathname = window.location.pathname;
        
        // WordPressのインストールパスを抽出（例: /stg.vegegrow/）
        const wpPath = pathname.split('/').slice(0, -1).join('/') || '';
        const restApiBase = `${baseUrl}${wpPath}/wp-json`;
        
        const endpoint = `${restApiBase}/vege/v1/instagram?cacheBust=${Date.now()}`;
        const testEndpoint = `${restApiBase}/vege/v1/test`;
        
        try {
            console.log('Fetching from Instagram API via REST endpoint:', endpoint);
            console.log('Current origin:', window.location.origin);
            console.log('Current pathname:', window.location.pathname);
            console.log('REST API base:', restApiBase);
            
            // まずテストエンドポイントでREST APIが動作しているか確認
            try {
                const testResponse = await fetch(testEndpoint, {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: {
                        'Accept': 'application/json',
                    }
                });
                console.log('Test endpoint response:', testResponse.status, testResponse.ok);
                if (testResponse.ok) {
                    const testData = await testResponse.json();
                    console.log('Test endpoint data:', testData);
                } else {
                    console.warn('Test endpoint returned:', testResponse.status);
                    // 404の場合はREST APIエンドポイントが登録されていない可能性
                    if (testResponse.status === 404) {
                        console.error('REST API endpoint not found. Please check:');
                        console.error('1. functions.php is loaded correctly');
                        console.error('2. rest_api_init hook is firing');
                        console.error('3. WordPress permalink settings (should NOT be "Plain")');
                        console.error('4. Check /wp-json/ endpoint:', `${restApiBase}/`);
                        console.error('5. Try accessing:', testEndpoint);
                    }
                }
            } catch (testError) {
                console.warn('Test endpoint failed:', testError);
            }
            
            const response = await fetch(endpoint, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                }
            }).catch(fetchError => {
                // fetch自体が失敗した場合（CORS、ネットワークエラーなど）
                console.error('Fetch failed:', {
                    error: fetchError,
                    message: fetchError.message,
                    endpoint: endpoint,
                    origin: window.location.origin,
                    restApiBase: restApiBase
                });
                throw new Error(`Network error: ${fetchError.message}. Endpoint: ${endpoint}`);
            });
            
            if (!response.ok) {
                // エラーレスポンスの詳細を取得
                let errorText = '';
                let errorData = null;
                try {
                    errorText = await response.text();
                    // JSON形式のエラーレスポンスをパース
                    try {
                        errorData = JSON.parse(errorText);
                    } catch (e) {
                        // JSONでない場合はそのまま使用
                    }
                } catch (e) {
                    errorText = 'Could not read error response';
                }
                
                console.error('API Error Response:', {
                    status: response.status,
                    statusText: response.statusText,
                    url: response.url,
                    headers: Object.fromEntries(response.headers.entries()),
                    body: errorText.substring(0, 500), // 最初の500文字のみ
                    parsed: errorData
                });
                
                // 404エラーの場合の詳細なメッセージ
                if (response.status === 404) {
                    throw new Error(`REST API endpoint not found (404). Please verify:
1. functions.php is loaded and rest_api_init hook is firing
2. WordPress permalink settings are not set to "Plain" (Settings > Permalinks)
3. Check if endpoint exists: ${endpoint}
4. Try accessing: ${restApiBase}/ to see available endpoints
5. Check WordPress debug log for REST API registration errors`);
                }
                
                // 401エラー（トークン期限切れ）の場合の特別な処理
                if (response.status === 401 || (errorData && errorData.code === 'instagram_token_expired')) {
                    const errorMessage = errorData?.message || 'Instagramアクセストークンの有効期限が切れています。';
                    console.error('Instagram token expired:', {
                        message: errorMessage,
                        error_code: errorData?.data?.error_code,
                        error_type: errorData?.data?.error_type,
                        original_message: errorData?.data?.original_message
                    });
                    throw new Error(`Instagramアクセストークンの有効期限が切れています。新しいトークンを取得してfunctions.phpのIG_TOKEN定数を更新してください。\n詳細: ${errorMessage}`);
                }
                
                // 400エラー（その他のAPIエラー）の場合
                if (response.status === 400 && errorData) {
                    const errorMessage = errorData.message || 'Instagram API error';
                    console.error('Instagram API error:', {
                        code: errorData.code,
                        message: errorMessage,
                        data: errorData.data
                    });
                    throw new Error(`Instagram API error: ${errorMessage}`);
                }
                
                throw new Error(`HTTP error! status: ${response.status} - ${errorText.substring(0, 200)}`);
            }
            
            const data = await response.json();
            console.log('Instagram API response:', data);
            
            // WordPress REST APIレスポンス形式をチェック
            // エラーレスポンスの場合（WP_Error形式）
            if (data && data.code && data.message) {
                console.error('WordPress REST API error response:', data);
                if (data.code === 'instagram_token_expired') {
                    throw new Error(`Instagramアクセストークンの有効期限が切れています。新しいトークンを取得してfunctions.phpのIG_TOKEN定数を更新してください。\n詳細: ${data.message}`);
                }
                throw new Error(`Instagram API error: ${data.message}`);
            }
            
            if (!Array.isArray(data)) {
                throw new Error('Invalid API response format');
            }
            
            // データを整形（既にPHP側で整形済み）
            const imagePosts = data.map(post => ({
                id: post.id,
                imageUrl: post.imageUrl,
                caption: post.caption || '',
                link: post.link,
                timestamp: post.timestamp || ''
            }));
            
            console.log('Processed Instagram posts:', imagePosts.length);
            return imagePosts;
            
        } catch (error) {
            // endpoint変数は関数スコープで定義されているため、catchブロックでも参照可能
            console.error('Instagram API fetch error:', {
                error: error,
                message: error.message,
                stack: error.stack,
                endpoint: typeof endpoint !== 'undefined' ? endpoint : 'undefined',
                testEndpoint: typeof testEndpoint !== 'undefined' ? testEndpoint : 'undefined',
                restApiBase: typeof restApiBase !== 'undefined' ? restApiBase : 'undefined',
                origin: window.location.origin,
                pathname: window.location.pathname
            });
            
            // より詳細なエラーメッセージ
            if (error.message.includes('Failed to fetch') || error.message.includes('Network error')) {
                console.error('Network/CORS error detected. Possible causes:');
                console.error('1. REST API endpoint not registered');
                console.error('2. CORS headers not set correctly');
                console.error('3. Network connectivity issue');
                console.error('4. Endpoint URL incorrect');
            } else if (error.message.includes('404')) {
                console.error('404 error detected. Possible causes:');
                console.error('1. WordPress permalink settings set to "Plain"');
                console.error('2. REST API endpoint not registered in functions.php');
                console.error('3. Incorrect WordPress installation path');
                console.error('4. .htaccess file missing or incorrect');
            }
            
            throw error;
        }
    }
    
    /**
     * 投稿データを表示
     * @param {HTMLElement} container - コンテナ要素
     * @param {Array} posts - 投稿データの配列
     */
    function displayInstagramPosts(container, posts) {
        console.log('Displaying Instagram posts:', posts.length);
        container.innerHTML = '';
        
        if (posts.length === 0) {
            console.log('No posts to display');
            container.innerHTML = '<p class="instagram-error">投稿が見つかりませんでした。</p>';
            return;
        }
        
        posts.forEach((post, index) => {
            const item = createInstagramItem(post, index);
            container.appendChild(item);
            
            // 遅延アニメーション
            setTimeout(() => {
                item.classList.add('is-visible');
            }, index * 100);
        });
        
        console.log('Instagram posts displayed successfully');
    }
    
    /**
     * フォールバックデータを表示（API取得失敗時）
     * @param {HTMLElement} container - コンテナ要素
     */
    function displayFallbackData(container) {
        const fallbackPosts = [
            {
                id: 1,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img1.webp',
                caption: '新鮮なアスパラガス',
                link: 'https://www.instagram.com/p/sample1/'
            },
            {
                id: 2,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img2.webp',
                caption: '高級トリュフ',
                link: 'https://www.instagram.com/p/sample2/'
            },
            {
                id: 3,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img3.webp',
                caption: '畑での作業風景',
                link: 'https://www.instagram.com/p/sample3/'
            },
            {
                id: 4,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img4.webp',
                caption: '松茸',
                link: 'https://www.instagram.com/p/sample4/'
            },
            {
                id: 5,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img5.webp',
                caption: 'スライスされたトリュフ',
                link: 'https://www.instagram.com/p/sample5/'
            },
            {
                id: 6,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img6.webp',
                caption: '黄色のパプリカ',
                link: 'https://www.instagram.com/p/sample6/'
            },
            {
                id: 7,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img7.webp',
                caption: '広大な畑',
                link: 'https://www.instagram.com/p/sample7/'
            },
            {
                id: 8,
                imageUrl: 'https://haconiwa.co/client/vegegrow/wp-content/themes/vegegrow_theme/dist/images/sample_img8.webp',
                caption: '赤とオレンジのパプリカ',
                link: 'https://www.instagram.com/p/sample8/'
            }
        ];
        
        displayInstagramPosts(container, fallbackPosts);
    }
    
    /**
     * キャプションを指定文字数で切り詰め
     * @param {string} caption - 元のキャプション
     * @param {number} maxLength - 最大文字数
     * @returns {string} 切り詰められたキャプション
     */
    function truncateCaption(caption, maxLength = 100) {
        if (!caption) return '';
        if (caption.length <= maxLength) return caption;
        return caption.substring(0, maxLength) + '...';
    }
    
    /**
     * Instagramデータをキャッシュに保存
     * @param {Array} posts - 投稿データ
     */
    function cacheInstagramData(posts) {
        const cacheData = {
            posts: posts,
            timestamp: Date.now()
        };
        
        try {
            localStorage.setItem('instagram_feed_cache', JSON.stringify(cacheData));
        } catch (error) {
            console.warn('Failed to cache Instagram data:', error);
        }
    }
    
    /**
     * キャッシュからInstagramデータを取得
     * @returns {Object|null} キャッシュデータ
     */
    function getCachedInstagramData() {
        try {
            const cached = localStorage.getItem('instagram_feed_cache');
            return cached ? JSON.parse(cached) : null;
        } catch (error) {
            console.warn('Failed to get cached Instagram data:', error);
            return null;
        }
    }
    
    /**
     * キャッシュが期限切れかチェック
     * @param {number} timestamp - キャッシュのタイムスタンプ
     * @returns {boolean} 期限切れの場合true
     */
    function isCacheExpired(timestamp) {
        const CACHE_DURATION = 30 * 60 * 1000; // 30分
        return Date.now() - timestamp > CACHE_DURATION;
    }
    
    /**
     * Instagramアイテムを作成
     * @param {Object} post - 投稿データ
     * @param {number} index - インデックス
     * @returns {HTMLElement} Instagramアイテム要素
     */
    function createInstagramItem(post, index) {
        const item = document.createElement('div');
        item.className = 'news-section__instagram-item';
        item.setAttribute('data-index', index);
        
        item.innerHTML = `
            <img src="${post.imageUrl}" alt="${post.caption}" class="news-section__instagram-image">
            <div class="news-section__instagram-overlay">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
            </div>
        `;
        
        // クリックイベント
        item.addEventListener('click', () => {
            window.open(post.link, '_blank', 'noopener,noreferrer');
        });
        
        return item;
    }
    
    /**
     * About Sectionのアニメーション初期化
     */
    function initAboutAnimation() {
        const aboutSection = document.querySelector('.about-section');
        
        if (!aboutSection) return;
        
        // Intersection Observerでスクロールアニメーション
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '0px 0px -100px 0px'
        });
        
        observer.observe(aboutSection);
    }
    
    /**
     * Contact Sectionのアニメーション初期化
     */
    function initContactAnimation() {
        const contactSection = document.querySelector('.contact-section');
        
        if (!contactSection) return;
        
        // Intersection Observerでスクロールアニメーション
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '0px 0px -100px 0px'
        });
        
        observer.observe(contactSection);
    }
    
    /**
     * ハンバーガーメニューの初期化
     */
    function initHamburgerMenu() {
        const hamburgerButton = document.getElementById('hamburger-menu');
        const mobileMenu = document.getElementById('mobile-menu');
        const closeButton = document.getElementById('mobile-menu-close');
        
        if (!hamburgerButton || !mobileMenu) return;
        
        // メニューの開閉を切り替える関数
        function toggleMenu() {
            const isActive = mobileMenu.classList.contains('active');
            
            if (isActive) {
                // メニューを閉じる
                hamburgerButton.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = ''; // スクロール復活
            } else {
                // メニューを開く
                hamburgerButton.classList.add('active');
                mobileMenu.classList.add('active');
                document.body.style.overflow = 'hidden'; // スクロール防止
            }
        }
        
        // ハンバーガーボタンクリックで開閉切り替え
        hamburgerButton.addEventListener('click', toggleMenu);
        
        // 閉じるボタンがある場合の処理
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                hamburgerButton.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        }
        
        // オーバーレイクリックで閉じる
        mobileMenu.addEventListener('click', function(e) {
            if (e.target === mobileMenu) {
                hamburgerButton.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
        
        // ESCキーで閉じる
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
                hamburgerButton.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            }
        });
        
        // メニューリンククリックで閉じる
        const menuLinks = mobileMenu.querySelectorAll('.site-header__mobile-nav-link');
        menuLinks.forEach(link => {
            link.addEventListener('click', function() {
                hamburgerButton.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }
    
    /**
     * スムーズスクロールの初期化
     */
    function initSmoothScroll() {
        // アンカーリンクを取得
        const anchorLinks = document.querySelectorAll('a[href^="#"]');
        
        anchorLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    // ヘッダーの高さを取得（レスポンシブ対応）
                    const headerHeight = getHeaderHeight();
                    
                    // ターゲット要素の位置を計算
                    const targetPosition = targetElement.offsetTop - headerHeight;
                    
                    // スムーズスクロール実行
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
    
    /**
     * ヘッダーの高さを取得（レスポンシブ対応）
     * @returns {number} ヘッダーの高さ（px）
     */
    function getHeaderHeight() {
        const header = document.querySelector('.site-header');
        if (!header) return 0;
        
        // ウィンドウ幅に応じてオフセットを調整
        const windowWidth = window.innerWidth;
        
        if (windowWidth >= 768) {
            // PC: 100px
            return 100;
        } else {
            // SP: 73px
            return 73;
        }
    }
    
    /**
     * ナビゲーションのアクティブ状態管理（トップページでのお知らせセクション用）
     */
    function initNavigationActiveState() {
        // トップページでのみ実行
        const isHomePage = window.location.pathname === '/' || 
                          window.location.pathname.includes('index.php') ||
                          window.location.pathname.includes('/stg.vegegrow/');
        
        if (!isHomePage) return;
        
        const newsSection = document.getElementById('news');
        const newsNavLink = document.querySelector('.site-header__nav-link[href*="#news"]');
        
        if (!newsSection || !newsNavLink) return;
        
        // Intersection Observerでスクロール位置を監視
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // お知らせセクションが表示されている時
                    newsNavLink.classList.add('site-header__nav-link--active');
                } else {
                    // お知らせセクションが表示されていない時
                    newsNavLink.classList.remove('site-header__nav-link--active');
                }
            });
        }, {
            threshold: 0.3, // セクションの30%が表示されたらアクティブ
            rootMargin: '-100px 0px -50% 0px' // ヘッダー分のオフセット
        });
        
        observer.observe(newsSection);
    }
    
    /**
     * ヒーローセクションのSwiper初期化
     */
    function initHeroSwiper() {
        const heroSwiper = document.querySelector('.hero-swiper');
        if (!heroSwiper) {
            console.log('Hero swiper element not found');
            return;
        }
        
        // Swiperが読み込まれているかチェック
        if (typeof Swiper === 'undefined') {
            console.log('Swiper is not loaded');
            return;
        }
        
        console.log('Initializing hero swiper');
        
        new Swiper('.hero-swiper', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loop: true,
            speed: 1000,
            allowTouchMove: false, // タッチ操作を無効化
        });
    }
    
})();
